import { Card } from '@climatetradecarbon/climatetrade-components'
import { useTranslation } from 'next-i18next'
import { CalculatorCardProps } from './CalculatorCard.props'

import styles from './CalculatorCard.module.scss'

/**
 * Calculator card component
 *
 * @description This component is used to display a calculator card wrapped in a link to access the actual calculator
 *
 * @component CalculatorCard
 * @param {CalculatorCardProps} props
 * @returns
 */
export default function CalculatorCard({
  pack,
  openCalculator
}: CalculatorCardProps) {
  // Get i18n instance from hook to get the current language
  const { i18n } = useTranslation()

  return (
    <div className={styles.CalculatorCard}>
      <Card
        icon={pack.icon}
        title={pack.title[i18n.language]}
        description={pack.description[i18n.language]}
        onClick={openCalculator}
      />
    </div>
  )
}
